<template>
  <div>
    <!-- Строка с автокомплитом и кнопкой -->
    <v-row align="center" no-gutters>
      <v-col>
        <autocomplete-multiple
          :name="$tools.isDefined(name) ? name : 'Теги'"
          :items="items"
          :select.sync="localSelect"
          :loading="state.isLoading"
          inline
          :class="mode!==undefined&&'mb-1'"
        >

          <template v-slot:customInfo="{item}">
            <chip class="mr-2" :color="item.color">
              <span :style="`color:${$tools.getContrastColor(item.color)}`">
                {{item.name}}
              </span>
            </chip>
          </template>

          <template v-slot:selectedInfo="{item}">
            <chip class="mr-2" :color="item.color">
              <span :style="`color:${$tools.getContrastColor(item.color)}`">
                {{item.name}}
              </span>
            </chip>
          </template>
        </autocomplete-multiple>
      </v-col>

      <!-- Кнопка шестерёнка -->
      <v-col cols="auto">
        <v-btn icon small @click="showSettings = !showSettings">
          <v-icon>
            {{ showSettings ? 'mdi-cog-off-outline' : 'mdi-cog-outline' }}
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Разворачиваемая панель -->
    <v-expand-transition>
      <div v-show="showSettings">
        <v-btn-toggle
          v-if="mode !== undefined"
          class="btn-toggle_small mt-2"
          v-model="localMode"
          mandatory
          dense
        >
          <v-btn small value="simple">
            Любой из
          </v-btn>
          <v-btn small value="strict">
            Все из списка
          </v-btn>
          <v-btn small value="exact">
            Точное совпадение
          </v-btn>
        </v-btn-toggle>

        <div class="d-flex align-center">
            <date-interval
              v-if="start!==undefined&&end!==undefined"
              class="mt-3"
              :valueFrom.sync="tagStartDate"
              :valueTo.sync="tagEndDate"
            />
            <tooltip right>
              <v-icon class="ml-1" small>mdi-help-circle-outline</v-icon>           
              <template v-slot:content>
                <p>Если указаны обе даты — «С» и «ПО»<br>
                <span class="font-weight-regular">Тег подходит, если он был активен хотя бы один день в этом интервале.</span></p>

                <p>Если указана только дата «С» (фильтр «от»)<br>
                <span class="font-weight-regular">Тег подходит, если он был активен в эту дату или позже.</span></p>

                <p>Если указана только дата «ПО» (фильтр «до»)<br>
                <span class="font-weight-regular">Тег подходит, если он был активен в эту дату или раньше.</span></p>
              </template>
            </tooltip>
        </div>

      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import State from "@/plugins/state";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import Chip from "../../componentsV2/base/Chip.vue";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";

import {
  Entity_Tag,
} from "../../../EntityStoreCacheService";

export default {
  components: {AutocompleteMultiple,Chip, DateInterval, Tooltip},
  props:['select', 'entityType', 'name', 'mode', 'start', 'end'],
  data:()=>({
    localSelect: null,
    state: new State(),
    items:[],
    localMode: 'simple',
    tagStartDate:null,
    tagEndDate:null,
    showSettings: false,
  }),
  mounted() {
    if (this.mode!==undefined)
      this.localMode = this.mode

    this.localSelect = this.select;
    let rb = new Entity_Tag()
        .selects(Entity_Tag.id)
        .selects(Entity_Tag.name)
        .selects(Entity_Tag.color)
        if (this.entityType!==undefined)
          rb.filterAnd([Entity_Tag.entity, Entity_Tag.type].join('.')+'=?',this.entityType)

        rb.order(Entity_Tag.name, true)
        .page(1).onPage(1000)
        .addStateCallback((v)=> this.state.setRequestBuilderState(v))
        .addStateCallback((v)=>{
          if(v.success)
            this.items = v.items;
        })
        .request()
  },
  watch: {
    select(v) {
      this.localSelect = v;
    },
    mode(v) {
      this.localMode = v
    },
    start(v) {
      this.tagStartDate = v
    },
    end(v) {
      this.tagEndDate = v
    },
    localSelect() {
      this.$emit('update:select', this.localSelect)
    },
    localMode() {
      this.$emit('update:mode', this.localMode)
    },
    tagStartDate(){
      this.$emit('update:start', this.tagStartDate);
    },
    tagEndDate(){
      this.$emit('update:end', this.tagEndDate);
    },

  }
}
</script>

<style lang="scss" scoped>
  .btn-toggle_small {
    display: flex;
    .v-btn {
      font-size: 8px;
      padding: 2px;
      flex-grow: 1;
    }
  }
</style>